import Qs from 'qs'
import axios from 'axios'
import router from '../router'
const actions = {
  GetPower ({ commit }, pageTag = '') {
    // console.log(router)
    if(router.history.current.name != 'Login') {
      axios({ url: '/Account/dataSearchVue/selectColAndAuthByFuncCode.html', type: 'post', params: Qs.stringify({ funcCode: pageTag }) }).then(({ data: res }) => {
          if (res.result == -1) {
            // 未登录/超时跳转由 axios 响应拦截器统一处理
            return false
          }
          if (res.code != 'success') return false
          let { data } = JSON.parse(res.result)
          commit('getPower', JSON.parse(data))
      })
    }
  },
  onLoading({ commit }, isLoading) {
    commit('setLoading', isLoading);
  },
  GetMenuList({ commit }, menuList) {
    commit('setMenuList', menuList);
  }
}
export default actions